/**
 * modules — עזרי gating במודולים פר-חברה ב-frontend.
 *
 * המקור: רשימת קודי הפרימיום הפעילים נטענת ב-login ונשמרת ב-localStorage תחת
 * `enabled-modules` (ראה Login.js). קודי בסיס תמיד פעילים (לא נשמרים).
 *
 * הערה (R6): הרשימה נטענת ב-login בלבד; toggle אמצע-סשן ע"י אדמין משתקף רק
 * אחרי re-login (כמו דפוס agentCount הקיים).
 */
import LocalstorageService from './localstorage-service';
import { EnabledModules } from '../constants';
import { BASIC_CODES, getCategoryChildren } from '../constants/moduleCatalog';

/** קבוצת קודי הפרימיום הפעילים לחברה הנוכחית (מ-localStorage). */
export const getEnabledModuleSet = () => {
  const arr = LocalstorageService.getItem(EnabledModules);
  return new Set(Array.isArray(arr) ? arr : []);
};

/** האם מודול פעיל: בסיס → תמיד true; פרימיום → לפי הרשימה הפעילה. */
export const isModuleEnabled = (code) => {
  if (BASIC_CODES.has(code)) return true;
  return getEnabledModuleSet().has(code);
};

/** האם לקטגוריה (Reports/Profitability) יש לפחות child פרימיום פעיל אחד. */
export const isCategoryEnabled = (category) => {
  const enabled = getEnabledModuleSet();
  return getCategoryChildren(category).some((m) => enabled.has(m.code));
};
